module.exports = function (css) {
    return css.replace(/{CLIENT_BASE_PATH}/g, '/');
};
